<template>

  <div id="messages-filter">
    <br/>
    <br/>
    <f7-list>
      <!-- Sélection des valeurs de Filtre -->
      <f7-list-item :class="{'filter-item-section':true, 'd-none': !displayFilter}">
        <b-row style="min-width: 100%">
          <!-- <b-col class="d-flex flex-row"> -->

          <!-- Filtre Name File -->
          <b-col xl="2" cols="6" class="filter-item mb-3">
            <span class="filter-item-title">{{ $t('filter.nameFile') }}</span>
            <span class="filter-item-content">
              <input v-model="NameFile"
                type="text"
                :class="{'filter-item-input': true, 'filter-item-input-complete': NameFile}"
                :placeholder="$t('filter.nameFile_placeholder')">
              </input>
            </span>
          </b-col>

          <!--<b-col xl="3" cols="6" class="filter-item mb-3">
            <span class="filter-item-title" style="margin-left: 2px">
              {{ $t('pain008.stat_global_imported_file') }}
            </span>
            <a :id="'status-picker-link' + '-' + filterType + '-' + randomString" class="filter-item-content"
              href="#">
              <i v-if="statusDisplay.icon" :class="statusDisplay.icon"></i>
              <div class="d-flex justify-content-between py-2">
                <span :class="{'filter-item-input-complete':statusDisplay.nb > 0}">{{ statusDisplay.label }}</span>
                <i class="fa-light fa-chevron-down text-right mr-2" id="status-chevron"></i>
              </div>
            </a>
            <b-popover :target="'status-picker-link' + '-' + filterType + '-' + randomString"
              :title="$t('filter.selected_status_none')"
              triggers="focus" placement="bottomright">
              <b-form-checkbox @change="selectAll()" v-model="allcheckedValid">
                {{ $t('pain008.select_all') }}
              </b-form-checkbox>
              <span v-for="Status in statusList" :key="Status.name">
                <b-form-checkbox v-model="Status.state" @change="decideLine()"
                  :value="1"
                  :unchecked-value="0">
                  <i :icon="Status.icon"></i>
                  <span>{{ Status.label }}</span>
                </b-form-checkbox>
              </span>
            </b-popover>
          </b-col>-->

          <!-- Filtre date de début -->
          <b-col xl="2" cols="5" class="filter-item mb-3">
            <span class="filter-item-title">
              {{ $t('common.date_start_label') }}</span>
            <span class="filter-item-content">
              <input v-model="DateBegin"
                type="date"
                :class="{'filter-item-input': true, 'filter-item-input-complete': DateBegin}"
                :placeholder="$t('common.slct_date')">
              </input>
            </span>
          </b-col>

          <!-- Filtre date de fin -->
          <b-col xl="2" cols="5" class="filter-item mb-3">
            <span class="filter-item-title">
              {{ $t('common.date_end_label') }}
            </span>
            <span class="filter-item-content">
              <input v-model="DateEnd"
                type="date"
                :class="{'filter-item-input': true, 'filter-item-input-complete': DateEnd}"
                :placeholder="$t('common.slct_date')">
              </input>
            </span>
          </b-col>

          <b-col xl="1" cols="12" class="mt-4 mr-3 text-center">
            <b-button class="btn" size="sm"
              @click="clearFilterFields"
              :disabled="!hasInputFilter"
              style="width: 80px; height: 28px">
              <i class="fa-light fa-xmark"></i>
            </b-button>
          </b-col>
          <b-col xl="1" cols="12" class="mt-4 text-center">
            <b-button class="btn btnApplyFilter" size="sm"
              @click="applyFilter(modeFilter)">
              <i class="fa-light fa-magnifying-glass"></i>
            </b-button>
          </b-col>
          <!-- Le nb de résultats retournés showLargeScreenOnly -->
          <b-col xl="2" class="mt-5 text-right showLargeScreenOnly">
            <b> {{countResult}} {{ $t('pain008.returned_result') }} </b>
          </b-col>
          <!-- Le nb de résultats retournés showSmallScreenOnly -->
          <b-col xl="2" cols="12" class="mt-5 text-center showSmallScreenOnly">
            <b> {{countResult}} {{ $t('pain008.returned_result') }} </b>
          </b-col>
        </b-row>
      </f7-list-item>
    </f7-list>
  </div>

</template>

<script>
import datePickerMixin from '@/mixins/datePickerMixin'
import Status from '@/helpers/status.js'
import {statusLabel, statusIcon} from '@/helpers/labels.js'
import services from '@/helpers/services.js'

export default {
  mixins: [datePickerMixin],
  name: 'MessagesFilter',
  props: {
    countResult: {
      type: String,
      default: ''
    },
    filterType: {
      type: String,
      default: 'list'
    },
    mode: {
      type: Number,
      default: 1
    },
    propedServiceId: {
      type: String,
      default: 'none'
    },
    randomId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      allcheckedValid: false,
      dir: 0,
      displayFilter: true,
      hasDefaultFilter: false,
      DateBegin: '',
      DateEnd: '',
      NameFile: '',
      Status: '',
      modeFilter: this.mode,
      services: services,
      statusList: [
        {
          code: 1,
          label: statusLabel(this.$i18n, Status.PROCESSED_PENDING),
          state: 0
        },
        {
          code: 2,
          label: statusLabel(this.$i18n, Status.PROCESS_REGISTERED),
          state: 0
        },
        {
          code: 3,
          label: statusLabel(this.$i18n, Status.FILE_REFUSED),
          state: 0
        },
        {
          code: 4,
          label: statusLabel(this.$i18n, Status.WAITING_DECISION),
          state: 0
        },
        {
          code: 98,
          label: statusLabel(this.$i18n, Status.ELIGIBLE_RECONSTRUCTION),
          state: 0
        },
        // {
        //   code: 7,
        //   label: statusLabel(this.$i18n, Status.PARTIALLY_TREATY),
        //   state: 0
        // },
        {
          code: 99,
          label: statusLabel(this.$i18n, Status.LOCK),
          state: 0
        }
      ],
      randomString: '',
      serviceId: ''
    }
  },
  created () {
    if (this.propedServiceId === 'none') {
      this.serviceId = this.$engine.user.currentService.id
    } else {
      this.serviceId = this.propedServiceId
    }
    this.filterTypeGet = this.filterType

    this.$bus.on('service:change', (val) => {
      this.serviceId = this.$engine.getServiceIdByName(val)
    })
    this.$bus.emit('right-panel-set-feature', 'filter-messages')

    // Command "apply filter" from the right-panel-filter-view (mobile)
    this.$bus.on('filter-apply-filter-' + this.randomId, (filter = {}) => {
      if (Object.keys(filter).length) {
        this.applyFilter(1, filter)
      } else {
        this.applyFilter()
      }
    })
    // Command "clear filter fields" from the right-panel-filter-view (mobile)
    this.$bus.on('filter-clear-filter-fields', () => {
      this.clearFilterFields()
    })
    // Command "save filter" from the right-panel-filter-view (mobile)
    this.$bus.on('filter-save-filter', () => {
      this.saveDefaultFilter()
    })
    // Command "delete filter" from the right-panel-filter-view (mobile)
    this.$bus.on('filter-delete-filter', () => {
      this.deleteFilter()
    })

    // Intercepts filter changes from the right-panel-filter-view (mobile)
    this.$bus.on('filter-update-fields', (filter) => {
      for (const property in filter) {
        if (this.statusList[property] !== undefined) {
          // Set filter status values
          this.statusList[property].state = filter[property]
        } else {
          // Set filter other values
          this[property] = filter[property]
        }
      }
    })
  },
  mounted () {
    this.dir = this.$settings.msgDirection
    this.randomString = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)

    let actualService = this.getActualService()
    var defaultFilter = {}
    switch (this.filterTypeGet) {
      case 'details':
        defaultFilter = actualService.filterDetails.getDefaultFilter()
        if (this.modeFilter === 2) {
          defaultFilter.statusDocRejected = 1
          defaultFilter.statusDocValidated = 1
        }
        break
      case 'draft':
        defaultFilter = actualService.filterDraft.getDefaultFilter()
        break
      case 'group':
        defaultFilter = actualService.filterGroup.getDefaultFilter()
        break
      case 'list':
        defaultFilter = actualService.filter.getDefaultFilter()
        break
      default:
        break
    }

    // Set default filter values
    this.setDefaultFilter(defaultFilter)

    // Warns right-panel-filter-view (mobile) that default values have been applied
    this.communicateChange()
  },
  beforeDestroy () {
    // this.$bus.emit('right-panel-clear-feature', 'filter-messages')
    this.$bus.off('service:change')
    this.$bus.off('filter-update-fields')
    this.$bus.off('filter-apply-filter-' + this.randomId)
    this.$bus.off('filter-save-filter')
    this.$bus.off('filter-delete-filter')
  },
  computed: {
    filterFields () {
      let that = this
      let filter = {}

      filter.DateBegin = this.DateBegin
      filter.DateEnd = this.DateEnd
      filter.Status = this.Status
      filter.NameFile = this.NameFile

      // Status values
      for (let property in this.statusList) {
        let Status = that.statusList[property]
        filter[property] = Status.state
      }
      return filter
    },
    hasInputFilter () {
      if ((this.statusDisplay.nb > 0 && this.modeFilter !== 2) ||
        this.DateBegin ||
        this.DateEnd ||
        this.Status ||
        this.NameFile) {
        return true
      }
      return false
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    realStatusList () {
      let that = this
      const list = []
      for (const property in that.statusList) {
        const Status = that.statusList[property]
        list.push({
          tag: property,
          label: Status.label,
          icon: Status.icon,
          state: Status.state
        })
      }
      return list
    },
    statusDisplay () {
      let realStatusList = this.realStatusList.filter(Status => Status.state === 1)
      if (realStatusList.length === 0) {
        return {
          label: this.$t('filter.selected_status_none'),
          nb: 0
        }
      } else if (realStatusList.length === 1) {
        return {
          label: realStatusList[0].label,
          icon: realStatusList[0].icon,
          nb: 1
        }
      } else {
        let finalLabel
        if (realStatusList.length === this.realStatusList.length) {
          finalLabel = this.$t('pain008.select_all')
        } else {
          finalLabel = realStatusList[0].label
          for (let i = 1; i < realStatusList.length; i++) {
            finalLabel += ', ' + realStatusList[i].label
          }
        }
        return {
          label: finalLabel,
          nb: realStatusList.length
        }
      }
    }
  },
  methods: {
    allLineSelect () {
        let i = 0
        while ((i < this.statusList.length) && (this.statusList[i].state === 1)) {
          i++
        }
        if (i === this.statusList.length) {
          this.allcheckedValid = true
        }
    },
    applyFilter (mode = 1, filterConditions = {}) {
      let that = this

      let actualService = this.getActualService()
      let actualFilter = actualService.filter
      actualFilter.cleanFilterCondition()

      let statusSelected = []
      for (let property in this.statusList) {
        let Status = that.statusList[property]
        if(Status.state === 1) {
          statusSelected.push(Status.code)
        }
      }

      actualFilter.DateBegin = this.DateBegin
      actualFilter.DateEnd = this.DateEnd ? (this.DateEnd + 'T23:59:59') : ''
      actualFilter.Status = statusSelected
      actualFilter.NameFile = this.NameFile
      actualFilter.modeFilter = mode

      for (let propertyCustom in filterConditions) {
        actualFilter[propertyCustom] = filterConditions[propertyCustom]
      }

      this.$emit('applyFilter', actualFilter.getConditionObject())
    },
    clearFilterFields () {
      let that = this
      for (let property in that.statusList) {
        that.statusList[property].state = 0
      }

      if (this.modeFilter === 2 && this.serviceId === services.DOCUMENTSERVICE) {
        that.statusList.statusDocRejected.state = 1
        that.statusList.statusDocValidated.state = 1
      }

      this.DateBegin = ''
      this.DateEnd = ''
      this.Status = ''
      this.NameFile = ''
      this.communicateChange()
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    decideLine () {
      if (this.allcheckedValid) {
        this.allcheckedValid = false
      }
      this.allLineSelect()
    },
    deleteFilter () {
      let actualService = this.getActualService()
      switch (this.filterTypeGet) {
        case 'details':
          actualService.filterDetails.saveDefaultFilter({})
          break
        case 'draft':
          actualService.filterDraft.saveDefaultFilter({})
          break
        case 'group':
          actualService.filterGroup.saveDefaultFilter({})
          break
        case 'list':
          actualService.filter.saveDefaultFilter({})
          break
        default:
          actualService.filter.saveDefaultFilter({})
          break
      }
      this.hasDefaultFilter = false
      this.$f7.modal({
        title: this.$t('administration.del_filter'),
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    getActualService () {
      let serviceName = {
        '9': this.$engine.pain08
      }
      return serviceName[this.serviceId]
    },
    saveDefaultFilter () {
      let that = this

      let actualService = this.getActualService()

      let defaultFilter = {
        DateBegin: this.DateBegin,
        DateEnd: this.DateEnd,
        Status: this.Status,
        NameFile: this.NameFile
      }

      for (const property in this.statusList) {
        let Status = that.statusList[property]
        defaultFilter[property] = Status.state
      }

      switch (this.filterTypeGet) {
        case 'details':
          actualService.filterDetails.saveDefaultFilter(defaultFilter)
          break
        case 'draft':
          actualService.filterDraft.saveDefaultFilter(defaultFilter)
          break
        case 'group':
          actualService.filterGroup.saveDefaultFilter(defaultFilter)
          break
        case 'list':
          actualService.filter.saveDefaultFilter(defaultFilter)
          break
        default:
          actualService.filter.saveDefaultFilter(defaultFilter)
          break
      }

      if (this.hasInputFilter) {
        this.hasDefaultFilter = true
      }

      that.$f7.modal({
        title: this.$i18n.t('filter.dflt_fltr_svd'),
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    selectAll () {
      for (let index = 0; index < this.statusList.length; index++) {
        this.statusList[index].state = (this.allcheckedValid) ? 1 : 0
      }
    },
    setDefaultFilter (defaultFilter) {
      for (const property in defaultFilter) {
        if (this.statusList[property] !== undefined) {
          // Set filter status values
          this.statusList[property].state = defaultFilter[property]
          if (defaultFilter[property] === 1) {
            this.hasDefaultFilter = true
          }
        } else {
          // Set filter other values
          if (property !== 'modeFilter') {
            this[property] = defaultFilter[property]
            if (this[property]) {
              this.hasDefaultFilter = true
            }
          }
        }
      }
    },
    updateCheckall () {
      if(this.statusList.length == this.statusList.length){
         this.allcheckedValid = 1
      }else{
         this.allcheckedValid = 0
      }
    }
  },
  watch: {
    DateBegin () {
      this.communicateChange()
    },
    DateEnd () {
      this.communicateChange()
    },
    hasDefaultFilter () {
      this.communicateChange()
    },
    NameFile () {
      this.communicateChange()
    },
    Status () {
      this.communicateChange()
    },
    statusList: {
      deep: true,
      handler () {
        this.communicateChange()
      }
    }
  }
}
</script>
